<div [class]="'next-offers-comparison-dialog next-offers-comparison-dialog--offers-' + offers.length"
     [ngClass]="{
      'next-offers-comparison-dialog--shadow': contentScrolled,
      'next-offers-comparison-dialog--single-offer': singleOfferMode,
      'next-offers-comparison-dialog--selected-offer': !data.fromOffersStep
    }">

    <div class="next-dialog__sticky">
        <div class="next-dialog__header">
            <div class="next-dialog__header__title">
                {{ offersPresentationService.dialogTitle | translate }}
            </div>

            <div class="next-dialog__header__close"
                 (click)="close()">
                <span class="material-icons">close</span>
            </div>
        </div>

        <div class="next-offers-comparison-dialog__header">
            <div *ngIf="isCarOne"
                 class="next-offers-comparison-dialog__header__offer">
                <app-next-offer [offer]="offers[0]"
                                (select)="selectOffer(offers[0])"
                ></app-next-offer>
            </div>
            <div *ngIf="!isCarOne"
                 class="next-offers-comparison-dialog__left-col next-offers-comparison-dialog__header__insurance-details">
                <app-shortened-vehicle-info *ngIf="!offersPresentationService.isNext"
                                            [context]="'OFFERS_PRESENTATION'">
                </app-shortened-vehicle-info>
                <div *ngIf="offersPresentationService.isNext"
                     class="offers-presentation-dialog__insurance-data">
                    <app-insurance-data-summary *ngIf="offersPresentationService.isNext"
                                                [context]="DataSummaryContext.OFFERS_PRESENTATION"
                                                [headerVisible]="false">
                    </app-insurance-data-summary>
                </div>
            </div>
            <div *ngIf="!isCarOne"
                 class="next-offers-comparison-dialog__right-col">
                <div *ngFor="let offer of offers"
                     class="next-offers-comparison-dialog__right-col__cell next-offers-comparison-offer-header">
                    <div class="next-offers-comparison-offer-header__logo">
                        <img *ngIf="offerResourceService.hasOfferLogo(offer)"
                             [src]="offerResourceService.getOfferLogoUri(offer)">
                        <span class="material-icons next-offers-comparison-offer-header__logo__remove-btn"
                              *ngIf="offersPresentationService.removeOfferVisible"
                              (click)="offersPresentationService.removeOffer(offer.id)">{{removeIcon}}</span>
                    </div>
                    <div class="next-offers-comparison-offer-header__price">
                        <app-offer-fixed-price [offer]="offer" [showInstalment]="false"></app-offer-fixed-price>
                    </div>
                    <div *ngIf="offersPresentationService.isNext"
                         class="next-offers-comparison-offer-header__buy">
                        <button *ngIf="offersPresentationService.buyOnlineButtonVisible"
                                class="btn btn--secondary btn--big"
                                (click)="selectOffer(offer)">
                            {{'OFFER_SECTION.SHARED.buyOnline' | translate}} <span *ngIf="!offersPresentationService.isNext">&#62;&#62;</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="next-offers-comparison-dialog__details">
        <app-offers-comparison-coverages-group *ngFor="let group of coveragesComparisonData"
                                               [coveragesGroup]="group"
                                               [offers]="offers"
        ></app-offers-comparison-coverages-group>
    </div>

    <div class="next-offers-comparison-dialog__row next-offers-comparison-dialog-footer">
        <div class="next-offers-comparison-dialog__left-col next-offers-comparison-dialog-footer__label">
            {{ 'OFFER_SECTION.COMPARE.generalInsuranceConditions' | translate }}
        </div>
        <div class="next-offers-comparison-dialog__right-col">
            <div *ngFor="let offer of offers"
                 class="next-offers-comparison-dialog__right-col__cell">
                <a class="next-offers-comparison-dialog-footer__owu-btn"
                   target="_blank"
                   [href]="offerResourceService.getOfferOWUUri(offer)">
                    <img [src]="owuDownloadIcon">
                    <span class="next-offers-comparison-dialog-footer__owu-btn__download">
                        {{ downloadOWUButtonLabel | translate }}
                      </span>
                </a>
            </div>
        </div>
    </div>
</div>
